import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import home  from './../pages/home';
const login = () => import('./../pages/user/login.vue')
const maps = () => import('./../pages/map.vue')
const tickerDetail = () => import('./../pages/ticket/tickerDetail.vue')
const shopDetail = () => import('./../pages/shop/detail.vue')
const shopList = () => import('./../pages/shop/list.vue')
const goodsdetail = () => import('./../pages/cell/goodsDetail.vue')
const goodssearch = () => import('./../pages/cell/goodsSearch.vue')
const goodssearchlist = () => import('./../pages/cell/goodsSearchList.vue')
const cart = () => import('./../pages/shopcart/cart.vue')
const user = () => import('./../pages/user/index.vue')
const orderlist = () => import('./../pages/user/order.vue')
const orderdetail = () => import('./../pages/cell/orderdetail.vue')
const ticketList = () => import('./../pages/user/ticket.vue')
const myFootPrint = () => import('./../pages/user/myFootPrint.vue')
const cardList = () => import('./../pages/user/card.vue')
const consumeList = () => import('./../pages/user/consume.vue')
const consumeDetail = () => import('./../pages/consume/detail.vue')
const collectionList = () => import('./../pages/user/collectionList.vue')
const gift = () => import('./../pages/user/gift.vue')
const giftdetail = () => import('./../pages/gift/detail.vue')
const logout = () => import('./../pages/user/logout.vue')
const editName = () => import('./../pages/user/editName.vue')
const address = () => import('./../pages/user/address.vue')
const goods = () => import('./../pages/cell/goods.vue')
const order = () => import('./../pages/cell/order.vue')
const card = () => import('./../pages/shopcard/card.vue')
const storeCard = () => import('./../pages/shopcard/store.vue')
const cardSuccess = () => import('./../pages/shopcard/success.vue')
const cardInfo = () => import('./../pages/shopcard/cardInfo.vue')
const cardDetail = () => import('./../pages/shopcard/detail.vue')
const memSystem = () => import('./../pages/shopcard/memSystem.vue')
import pay from './../pages/qcode/pay.vue';
const payfail = () => import('./../pages/cell/payfail.vue')
const addcashier = () => import('./../pages/cashier/addcashier.vue')
const addcashierdownload = () => import('./../pages/cashier/addcashierdownload.vue')
const addcashierpassword = () => import('./../pages/cashier/addcashierpassword.vue')
const ticketRule = () => import('./../pages/app/ticketRule.vue')
const inputbusiness = () => import('./../pages/apptransfer/inputbusiness.vue')
const inputbusiness10 = () => import('./../pages/apptransfer/inputbusinesschunnel10.vue')
const schoolArticleDetail = () => import('./../pages/apptransfer/schoolArticleDetail.vue')
const appMemSystem = () => import('./../pages/apptransfer/member.vue')
const helpList = () => import('./../pages/help/list.vue')
const helpDetail = () => import('./../pages/help/detail.vue')
const integral = () => import('./../pages/integral/index.vue')
const integralRule = () => import('./../pages/integral/rule.vue')
const noShop = () => import('./../pages/shop/no-shop.vue')
const appindex = () => import('./../pages/app/location.vue')
const membercard = () => import('./../pages/app/membercard.vue')
const gambleIndex = () => import('./../pages/game/gamble/index.vue')
const gambleList = () => import('./../pages/game/gamble/list.vue')
const gambleRecord = () => import('./../pages/game/gamble/record.vue')
const detailGame = () => import('./../pages/game/gamble/detailGame.vue')



export default new Router({
  routes: [
    // 店铺主页
    {
			path: '/',
			redirect: "/home",
      meta:{
        title:"首页"
      }
    },
		{
			path: '/home',
			name: 'home',
      component: home,
      meta:{
        title:"首页"
      }
    },
    //店铺地图
		{
			path: '/map',
			name: 'map',
      component: maps,
      meta:{
        title:"地图"
      }
		},
    //登录
    {
      name:'login',
      path:'/user/login',
      component: login,
      meta:{
        title:"登录"
      }
    },
    //优惠券详情
    {
			path: '/ticket/:id',
			name: 'tickerDetail',
			component: tickerDetail,
      meta:{
        title:"优惠券详情"
      }
    },
    //店铺资料
    {
			path: '/shop/detail',
			name: 'detail',
			component: shopDetail,
      meta:{
        title:"店铺资料"
      }
    },
    //店铺资料
    {
			path: '/shop/list',
			name: 'list',
			component: shopList,
      meta:{
        title:"全部营业网点"
      }
    },
     //商品详情
		{
			path: '/cell/goodsdetail',
			name: 'goodsdetail',
			component: goodsdetail,
      meta:{
        title:"商品详情"
      }
    },
    //搜索商品
		{
			path: '/cell/goodssearch',
			name: 'goodssearch',
			component: goodssearch,
      meta:{
        title:"搜索商品"
      }
    },
    //搜索商品列表
		{
			path: '/cell/goodssearchlist',
			name: 'goodssearchlist',
			component: goodssearchlist,
      meta:{
        title:"搜索商品"
      }
    },
    //购物车
		{
			path: '/shopcart/cart',
			name: 'cart',
			component: cart,
      meta:{
        title:"购物车"
      }
    },
    //个人中心
    {
      path: '/user',
      name: 'user',
      component: user,
      meta:{
        title:"个人中心"
      }
    },
    //订单列表
		{
			path: '/user/orderlist',
			name: 'orderlist',
			component: orderlist,
      meta:{
        title:"商品订单"
      }
    },
    //订单详情
		{
			path: '/cell/orderdetail',
			name: 'orderdetail',
			component: orderdetail,
      meta:{
        title:"订单详情"
      }
		},
     //优惠券列表
    {
      name:'ticketList',
      path:'/user/ticketList',
      component: ticketList,
      meta:{
        title:"优惠券列表"
      }
    },
    //我的足迹
    {
      name:'myFootPrint',
      path:'/user/myFootPrint',
      component: myFootPrint,
      meta:{
        title:"我的足迹"
      }
    },
    //卡包列表
    {
      name:'cardList',
      path:'/user/card',
      component: cardList,
      meta:{
        title:"卡包列表"
      }
    },
    //消费记录列表
    {
      name:'consumeList',
      path:'/consume',
      component: consumeList,
      meta:{
        title:"消费记录"
      }
    },
    //消费记录详情
    {
      name:'consumeDetail',
      path:'/consume/detail',
      component: consumeDetail,
      meta:{
        title:"消费记录"
      }
    },
    //我的店铺收藏
    {
      name:'collectionList',
      path:'/user/collectionList',
      component: collectionList,
      meta:{
        title:"我的店铺收藏"
      }
    },
    //我的礼品
		{
			path: '/gift',
			name: 'gift',
			component: gift,
      meta:{
        title:"我的礼品"
      }
    },
    //我的礼品
		{
			path: '/gift/detail',
			name: 'giftdetail',
			component: giftdetail,
      meta:{
        title:"礼品"
      }
    },
    //账号管理
		{
			path: '/user/logout',
			name: 'logout',
			component: logout,
      meta:{
        title:"账号管理"
      }
    },
    //昵称
		{
			path: '/user/edit',
			name: 'editName',
			component: editName,
      meta:{
        title:"昵称"
      }
    },
    //收货地址
		{
			path: '/user/address',
			name: 'address',
			component: address,
      meta:{
        title:"收货地址"
      }
    },
    //外卖 - 商品列表模版（1）
		{
			path: '/cell',
			name: 'goods',
			component: goods,
      meta:{
        title:"全部商品"
      }
    },
    //提交订单
		{
			path: '/cell/order',
			name: 'order',
			component: order,
      meta:{
        title:"提交订单"
      }
    },
    //会员卡
		{
			path: '/shopcard/card',
			name: 'card',
			component: card,
      meta:{
        title:"会员"
      }
    },
    //储值卡
		{
			path: '/shopcard/store',
			name: 'storeCard',
			component: storeCard,
      meta:{
        title:"储值卡"
      }
    },
    //会员充值成功
		{
			path: '/shopcard/success',
			name: 'cardSuccess',
			component: cardSuccess,
      meta:{
        title:"会员储值"
      }
    },
    //折扣卡，计次卡领取
		{
			path: '/shopcard/info',
			name: 'cardInfo',
			component: cardInfo,
    },
    //会员卡详情
		{
			path: '/shopcard/detail',
			name: 'cardDetail',
			component: cardDetail,
      meta:{
        title:"会员卡"
      }
    },
    //会员说明
		{
			path: '/shopcard/member',
			name: 'memSystem',
			component: memSystem,
      meta:{
        title:"会员说明"
      }
    },
    //支付
    {
			path: '/qcode/:id',
			name: 'pay',
			component: pay,
      meta:{
        title:"支付"
      }
    },
    //支付失败
		{
			path: '/cell/payfail',
			name: 'payfail',
			component: payfail,
      meta:{
        title:"支付失败"
      }
    },
     //app添加收银员
    {
      name:'addcashier',
      path:'/cashier/addcashier',
      component: addcashier,
      meta:{
        title:"添加收银员"
      }
    },
      //app下载
    {
      name:'addcashierdownload',
      path:'/cashier/addcashierdownload',
      component: addcashierdownload,
      meta:{
        title:"app下载"
      }
    },
    //app收银员修改密码
    {
      name:'addcashierpassword',
      path:'/cashier/addcashierpassword',
      component: addcashierpassword,
      meta:{
        title:"修改密码"
      }
    },
    //app调用 优惠券规则页（京东）
		{
			path: '/ticket/:id/rule',
			name: 'ticketRule',
			component: ticketRule,
      meta:{
        title:"优惠券规则页"
      }
    },
    //app调用商家信息
    {
      name:'inputbusiness',
      path:'/apptransfer/inputbusiness',
      component: inputbusiness,
      meta:{
        title:"协议"
      }
    },
    //app调用商家信息
    {
      name:'inputbusiness10',
      path:'/apptransfer/inputbusinesschunnel10',
      component: inputbusiness10,
      meta:{
        title:"协议"
      }
    },
    //app调用商家信息
    {
      name:'schoolArticleDetail',
      path:'/apptransfer/schoolArticleDetail',
      component: schoolArticleDetail,
      meta:{
        title:"协议"
      }
    },
    //会员体系
    {
      name:'appMemSystem',
      path:'/apptransfer/member',
      component: appMemSystem,
      meta:{
        title:"会员体系"
      }
    },
    //商家帮助
    {
      name:'helpList',
      path:'/help/list',
      component: helpList,
      meta:{
        title:"商家帮助"
      }
    },
    //商家帮助详情
    {
      name:'helpDetail',
      path:'/help/detail',
      component: helpDetail,
      meta:{
        title:"详情"
      }
    },
    //我的积分
    {
      name:'integral',
      path:'/integral/index',
      component: integral,
      meta:{
        title:"我的积分"
      }
    },
    //积分规则
    {
      name:'integralRule',
      path:'/integral/rule',
      component: integralRule,
      meta:{
        title:"积分规则"
      }
    },
    //店铺停用
    {
      name:'noShop',
      path:'/shop/noShop',
      component: noShop,
      meta:{
        title:"该商户还未开通该服务"
      }
    },
    //app跳转
		{
			path: '/app/:id',
			name: 'appindex',
			component: appindex
    },
    {
			path: '//app/:id',
			name: 'appindex',
			component: appindex
    },
    //收银app 调用会员卡页面
    {
			path: '/membercard/:id',
			name: 'membercard',
      component: membercard,
      meta:{
        title:"服务已下架"
      }
    },
    //博饼游戏首页
    {
      path:'/gamble/index',
      name:'gambleIndex',
      component: gambleIndex,
      meta:{
        title:"博饼"
      }
    },
    //博饼游戏列表
    {
      path:'/gamble/list',
      name:'gambleList',
      component: gambleList,
      meta:{
        title:"中秋博饼"
      }
    },
    //博饼游戏中奖记录
    {
      path:'/gamble/record',
      name:'gambleRecord',
      component: gambleRecord,
      meta:{
        title:"我的中奖记录"
      }
    },
    //博饼游戏中奖记录
    {
      path:'/gamble/detailGame',
      name:'detailGame',
      component: detailGame,
      meta:{
        title:"活动已删除"
      }
    },



  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js